// Environment configuration for the bike tracker frontend

export const config = {
  // API Configuration
  apiBaseUrl:
    import.meta.env.VITE_API_BASE_URL ||
    "https://api.bettercitiescompany.com/api/v1",

  // WebSocket Configuration
  websocketUrl: import.meta.env.VITE_WEBSOCKET_URL || getDefaultWebSocketUrl(),

  // Environment detection
  isDevelopment: import.meta.env.DEV,
  isProduction: import.meta.env.PROD,

  // Other configurations
  enableDebugLogs:
    import.meta.env.VITE_DEBUG_LOGS === "true" || import.meta.env.DEV,
};

function getDefaultWebSocketUrl(): string {
  // In development, use localhost
  if (import.meta.env.DEV) {
    return "ws://localhost:3001";
  }

  // In production, derive WebSocket URL from API URL
  const apiUrl =
    import.meta.env.VITE_API_BASE_URL ||
    "https://api.bettercitiescompany.com/api/v1";

  // Extract base URL and convert to WebSocket URL
  const baseUrl = apiUrl.replace("/api/v1", "");

  if (baseUrl.startsWith("https://")) {
    return baseUrl.replace("https://", "wss://");
  } else if (baseUrl.startsWith("http://")) {
    return baseUrl.replace("http://", "ws://");
  }

  // Fallback to production WebSocket URL
  return "wss://api.bettercitiescompany.com";
}

export default config;
